/* eslint-disable no-console */
import Glide from './vendors/glide.min';

const heroSlider = {
  glide: null,
  disableAutoplay: true,
  apiLoaded: false,
  iframes: document.querySelectorAll('#hero-slider iframe'),
  players: [],
  getPlayerById: (id) => {
    let player;
    for (let i = 0; i < heroSlider.players.length; i++) { /* eslint-disable-line no-plusplus */
      if (id === heroSlider.players[i].a.id) {
        player = heroSlider.players[i];
      }
    }
    return player;
  },
  onUpdate: () => {
    if (!heroSlider.apiLoaded) {
      return;
    }
    for (let i = 0; i < heroSlider.players.length; i++) { /* eslint-disable-line no-plusplus */
      if (parseInt(heroSlider.glide.index, 10) === parseInt(heroSlider.players[i].a.getAttribute('data-slideNum'), 10)) {
        heroSlider.players[i].playVideo();
      } else {
        heroSlider.players[i].pauseVideo();
      }
    }
  },
  onInteract: () => {
    if (!heroSlider.apiLoaded) {
      return;
    }
    // Pause any video
    for (let i = 0; i < heroSlider.players.length; i++) { /* eslint-disable-line no-plusplus */
      if (heroSlider.players[i].getPlayerState() === 1) {
        heroSlider.players[i].pauseVideo();
      }
    }
  },
  addControls: () => {
    let player;
    for (let i = 0; i < heroSlider.iframes.length; i++) { /* eslint-disable-line no-plusplus */
      player = new YT.Player(heroSlider.iframes[i].id, { /* eslint-disable-line no-undef */
        events: {
          'onReady': function (event) { /* eslint-disable-line func-names, quote-props */
            heroSlider.apiLoaded = true;
            const id = event.target.a.id; /* eslint-disable-line prefer-destructuring */
            const slides = document.querySelectorAll('#hero-slider .glide__slides li');
            if (slides.length > 1) {
              if (parseInt(document.getElementById(id).getAttribute('data-slideNum'), 10) !== parseInt(heroSlider.glide.index, 10)) {
                heroSlider.getPlayerById(id).pauseVideo();
              }
            }
            setTimeout(() => {
              // Because glide.js duplicates the div...
              const previews = document.querySelectorAll(`[data-videoId="preview_${id}"]`);
              for (let j = 0; j < previews.length; j++) { /* eslint-disable-line no-plusplus */
                previews[j].classList.add('loaded');
              }
              // document.getElementById(`preview_${id}`).classList.add('loaded');
            }, 1000);
          },
          'onStateChange': function () { }, /* eslint-disable-line func-names, quote-props */
        },
      });
      heroSlider.players.push(player);
    }
  },
};

window.onload = () => {
  const slides = document.querySelectorAll('#hero-slider .glide__slides li');
  if (slides.length > 1) {
    heroSlider.glide = new Glide('.glide', {
      type: 'carousel',
      startAt: 0,
      perView: 1,
      focusAt: 'center',
      gap: 0,
      autoplay: 0,
      breakpoints: {},
    });

    heroSlider.glide.mount();

    heroSlider.glide.on('run', () => {
      heroSlider.onUpdate();
    });
    heroSlider.glide.on('swipe.end', () => {
      if (!heroSlider.disableAutoplay) {
        heroSlider.glide.update({ autoplay: false });
        heroSlider.disableAutoplay = true;
      }
      heroSlider.onInteract();
    });
  }

  const tabs = document.querySelectorAll('#tab-slider .glide__slides li');
  if (tabs.length > 1) {
    new Glide('.glide', {
      type: 'carousel',
      startAt: 0,
      perView: 1,
      gap: 0,
    }).mount();
  }
  // YT
  const tag = document.createElement('script');
  tag.src = 'https://www.youtube.com/iframe_api';
  const firstScriptTag = document.getElementsByTagName('script')[0];
  firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
  const timer = setInterval(() => {
    try {
      if (YT) { /* eslint-disable-line no-undef */
        clearInterval(timer);
        heroSlider.addControls();
      }
    } catch (error) {
      // error
    }
  }, 1000);
};
/* eslint-enable no-console */
